import { AgendaItemDetails } from "@/models/prepareRecording";
import { BoldTextM, Breakpoint, TableRowModel } from "@enxcs/dap-ui-stratos";
import { formatAgendaTableDate, formatAgendaTableTime } from "./formatters";

export const filterAgendaItems = (agendaItems: AgendaItemDetails[], filterKey: string) => {
  const normalizedFilterKey = filterKey.trim().toLowerCase();

  return agendaItems.filter((agendaDetail) => {
    if (!agendaDetail.subjects || agendaDetail.subjects.length === 0) {
      return false;
    }

    if (!normalizedFilterKey) {
      return true;
    }

    const searchText = [
      agendaDetail.agendaName,
      agendaDetail.agendaType,
      formatAgendaTableDate(agendaDetail.startDate),
      formatAgendaTableTime(agendaDetail.startDate, agendaDetail.startTime, agendaDetail.endDate, agendaDetail.endTime),
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    return searchText.includes(normalizedFilterKey);
  });
};

export const createAgendaTableRows = (agendaItems: AgendaItemDetails[], selectedAgendaId: string): TableRowModel[] => {
  return agendaItems.map((agendaDetail) => {
    const isSelected = selectedAgendaId === agendaDetail.id;

    return {
      key: agendaDetail.id,
      value: agendaDetail.id,
      select: isSelected,
      cells: [
        {
          content: <BoldTextM>{agendaDetail.agendaType}</BoldTextM>,
          breakpoint: Breakpoint.M,
        },
        {
          content: formatAgendaTableDate(agendaDetail.startDate),
          breakpoint: Breakpoint.M,
        },
        {
          content: formatAgendaTableTime(agendaDetail.startDate, agendaDetail.startTime, agendaDetail.endDate, agendaDetail.endTime),
          breakpoint: Breakpoint.M,
        },
      ],
    };
  });
};
